module.exports = __webpack_public_path__ + "static/img/mangu.fb015e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mangu.jpg
// module id = nP56
// module chunks = 1